import React from "react";
import { FaSeedling } from "react-icons/fa";

// Shared visual for "nothing to show here yet" states — extracted from ComingSoonPage.jsx so
// the same card look can be reused for narrower cases (e.g. a page that exists and works for
// regular users, but has no defined View for a specific role like systemAdmin) without forcing
// that case through ComingSoonPage's servicesConfig-driven, whole-service flow.
//
// Re-themed to match the app's actual green FEED branding (--theme-color) instead of the
// original generic blue-button/barricade-emoji placeholder look.
// `pill` is opt-in, not defaulted — this component is also reused as ErrorBoundary.jsx's generic
// crash fallback, and a hardcoded "Coming Soon" badge there would mislabel a real error as a
// planned, unbuilt feature. Callers that are genuinely a Coming Soon page pass pill="Coming Soon"
// explicitly (see ComingSoonPage.jsx, LoansandSchemas.jsx, MyDirectoryPage.jsx, MyTradePage.jsx).
export default function ComingSoonNotice({ title, message, actionLabel, onAction, icon, pill }) {
  return (
    <div className="coming-soon-notice">
      <div className="coming-soon-notice__card">
        <div className="coming-soon-notice__badge-wrap">
          <div className="coming-soon-notice__badge">
            {icon || <FaSeedling />}
          </div>
        </div>
        {pill && <span className="coming-soon-notice__pill">{pill}</span>}
        <h2 className="coming-soon-notice__title">{title}</h2>
        <p className="coming-soon-notice__message">{message}</p>
        {actionLabel && onAction && (
          <button onClick={onAction} className="coming-soon-notice__action">
            {actionLabel}
          </button>
        )}
      </div>
    </div>
  );
}
